import { Icon } from "@iconify/react";
import { FloatButton } from "antd";

const WHATSAPP_PHONE_NUMBER = "5213333324037";
const WHATSAPP_MESSAGE = "Hola, requiero apoyo con la plataforma.";

/** El botón flotante de soporte por WhatsApp, en todos los layouts con sesión. */
const WhatsAppButton = () => {
  const sendMessageViaWhatsApp = () => {
    const whatsappUrl = `https://wa.me/${WHATSAPP_PHONE_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

    window.open(whatsappUrl, "_blank");
  };

  return (
    <FloatButton
      style={{
        width: 55,
        height: 55,
        insetInlineEnd: 15,
        zIndex: 40,
      }}
      icon={<Icon icon="nimbus:whatsapp" fontSize={23} />}
      tooltip={"Contactar"}
      onClick={sendMessageViaWhatsApp}
    />
  );
};

export default WhatsAppButton;
